<template>
  <div id="area">
    <DistrictTree  @addcheck-treedata="getTreeCheckDataRegion" :districtData="districtData" :districtTreeData="districtTreeData" :twoNodeArr="twoNodeArr"></DistrictTree>
    <div  class="right" :style="styleRight">
      <div class="operation">
        <div class="operationBtn">
          <el-button @click="deleteData" :disabled="delDisabled">{{$t('LanguageLib.DELETE')}}</el-button>
          <el-button type="primary" @click="addData">{{$t('LanguageLib.ADD_TO')}}</el-button>
          <el-button type="primary" @click="importData" :disabled="true">{{$t('LanguageLib.IMPORT')}}</el-button>
          <el-button type="primary" @click="exportData"  :disabled="true">{{$t('LanguageLib.EXPORT_PROPS')}}</el-button>
        </div>
        <div class="operationSearch">
          <el-input
            placeholder=""
            prefix-icon="el-icon-search"
            v-model="searchText"
            @keyup.enter.native="searchDomainList"
          >
          </el-input>
        </div>
      </div>
      <div class="tableParent">
        <el-table
          empty-text=" "
          :data="tableData"
          @selection-change="onSelectedListChange"
          @sort-change='sortChange'
          height="100%"
          style="width: auto;"
          stripe
          v-loading="loading"
          ref="table">
          <el-table-column
            type="selection"
            :disabled="true"
            width="45">
          </el-table-column>
<!--          地区编号-->
          <el-table-column
            prop="districtCode"
            :label="$t('LanguageLib.AREA_CODE')"
            sortable="custom"
            min-width="80">
          </el-table-column>
<!--          地区名称-->
          <el-table-column
            prop="districtName"
            :label="$t('LanguageLib.AREA_NAME')"
            min-width="170">
          </el-table-column>
<!--          上级地区-->
          <el-table-column
            prop="parentName"
            :label="$t('LanguageLib.SUPERIOR_AREA')"
            min-width="120">
          </el-table-column>
<!--          城市等级-->
          <el-table-column
            prop="tierCity"
            :label="$t('LanguageLib.CITY_LEVEL')"
            sortable="custom"
            min-width="100">
          </el-table-column>
          <el-table-column
            fixed="right"
            :label="$t('LanguageLib.Operation')"
            min-width="50">
            <template slot-scope="scope">
              <el-button
                @click.native.prevent="editAreaData(scope.row, scope.$index, tableData)"
                :title="$t('LanguageLib.Edit')"
                type="text"
                style="color:#fff;width:30px;height:30px;background-color:#3bc6b9;border-radius:50%;line-height:30px;padding:0;">
                <i class="iconfont">&#xe60c;</i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </div>
    </div>
</template>

<script>

import storeinformationApi from '../../api/storeinformation'
import DistrictTree from '@/components/regionTree.vue'
// import baseUrl from '@/utils/base'
export default {
  name: 'areaSetting',
  components: { DistrictTree },
  data () {
    return {
      loading: false,
      currentPage: 1,
      pageSize: 20,
      //   排序字段
      //   0：地区编号
      // 1：地区名称
      // 2：城市等级名称
      sort: true, // 正序逆序
      sortOrder: 0, // 排序字段
      prevSort: 'ascending', // 记录前一次的排序状态（elementUI默认有三种，即descending，ascending和null）
      prevProp: 0, // 记录前一次的prop值
      delDisabled: true,
      districtData: [],
      districtTreeData: [],
      twoNodeArr: [], // 地区节点
      tableData: [],
      tableDataId: '',
      domainId: '',
      isSearch: false,
      defaultSort: { prop: 'updateDate', order: 'descending' }, // 默认排序
      searchText: '',
      selectedList: [],
      parentId: '',
      parentName: '',
      pageTotal: 0, // 数据总数
      updateRouteQuery: () => {
        const query = this.$router.history.current.query
        const path = this.$router.history.current.path
        const newQuery = JSON.parse(JSON.stringify(query))
        newQuery.currentPage = this.currentPage
        newQuery.pageSize = this.pageSize
        newQuery.searchText = this.searchText
        newQuery.sort = this.sort
        newQuery.sortOrder = this.sortOrder
        newQuery.checkedStoreTypeData = this.checkedStoreTypeData
        newQuery.checkedModeOperationData = this.checkedModeOperationData
        newQuery.checkedBrandData = this.checkedBrandData
        newQuery.NoRefresh = true
        this.$router.push({ path, query: newQuery })
      },
      getAreaList: (pageIndex, pageSize, sort, sortOrder, searchVal, parentId) => {
        this.loading = true
        if (parentId === '') {
          parentId = null
        }
        const para = {
          pageIndex: pageIndex,
          pageSize: pageSize,
          sort: sortOrder,
          isAsc: sort,
          searchVal: searchVal,
          parentId: parentId
        }
        storeinformationApi.getAreaList('post', '/basicdata/district/page', para).then(
          res => {
            console.log(res)
            this.tableData = res.data.data
            this.pageTotal = res.data.total
            this.loading = false
            console.log(this.tableData)
          }
        )
      },
      styleRight: 'width: 80%;margin-left: 20%' // right默认宽度
    }
  },
  mounted () {
    this.getAreaList(this.currentPage, this.pageSize, this.sort, this.sortOrder, this.searchText)
    this.getAreaTreeData()
  },
  methods: {
    addData () {
      this.$router.push('/storeinformation/areasetting/editareainfo?type=add&parentId=' + this.parentId + '&parentName=' + this.parentName)
    },
    importData () {},
    exportData () {},
    deleteData () {
      this.$commonfun.confirm(this.$t('LanguageLib.ARE_YOU_SURE_YOU_WANT_TO_DELETE_IT1'), this.$t('LanguageLib.DELETE'), this.$t('LanguageLib.DETERMINE'), this.$t('LanguageLib.CANCEL'), false, 'warning', this)
        .then(() => {
          console.log(this.selectedList)
          this.selectedList = this.selectedList.map(x => {
            return x.id
          })
          console.log(this.selectedList)
          storeinformationApi.deleteAreaData('post', 'basicdata/district/delete', this.selectedList)
            .then((res) => {
              console.log(res)
              this.getAreaTreeData()
              this.getAreaList(this.currentPage, this.pageSize, this.sort, this.sortOrder, this.searchText)
              if (res.data.failCount === 0) {
                // 删除全部成功
                console.log('全部成功')
                this.$message({
                  type: 'success',
                  message: this.$t('LanguageLib.SUCCESSFULLY_DELETED')
                })
              } else if (res.data.successCount === 0) {
                // 全部失败
                console.log('全部失败')
                this.$message({
                  type: 'error',
                  message: this.$commonfun.stringFormat(this.$t('LanguageLib.SELECTED_OPERATION_FAIL'), this.$t('LanguageLib.Rebinding'))
                })
              } else {
                console.log('有成功有失败')
                // 有成功有失败
                this.$message({
                  type: 'info',
                  message: this.$commonfun.stringFormat(this.$t('LanguageLib.SELECTED_ORGANIZATION_TO_STORE_INFO'), res.data.successCount, res.data.failCount, this.$t('LanguageLib.DELETE'), this.$t('LanguageLib.DELETE'))
                })
              }
            }
            )
        }).catch()
      console.log('点击了删除')
    },
    sortChange (column) {
      console.log(column)
      if (column.order !== null) {
        console.log('order不等于空')
        this.prevSort = column.order
        if (column.order === 'ascending') {
          // 也就是正序,那么sort赋值为反的
          this.sort = false
          this.prevSort = 'ascending'
        } else if (column.order === 'descending') {
          this.prevSort = 'descending'
          this.sort = true
        }
        console.log('/////')
        console.log(this.sort)
        if (this.prevProp !== column.prop) {
          var columns = this.$refs.table.columns.find(item => item.property === this.prevProp)
          columns.order = ''
        }
      }
      if (column.order === null) {
        console.log('order等于空')
        column.column.order = this.prevSort === 'descending' ? 'ascending' : 'descending'
        column.order = this.prevSort === 'descending' ? 'ascending' : 'descending'
        this.prevProp = column.prop
        this.prevSort = column.column.order
        this.sortOrder = column.column.order !== 'descending'
      }
      switch (column.prop) {
        case 'districtCode':
          this.sortOrder = '0'
          break
        case 'districtName':
          this.sortOrder = 1
          break
        case 'tierCity':
          this.sortOrder = 2
          break
      }
      this.getAreaList(this.currentPage, this.pageSize, this.sort, this.sortOrder, this.searchText)
    },
    editAreaData (data, index, tableData) {
      console.log(data)
      console.log(tableData)
      this.$router.push('/storeinformation/areasetting/editareainfo?type=edit&pageIndex=' + this.currentPage + '&pageSize=' + this.pageSize + '&searchText=' + this.$commonfun.encodeUrl(this.searchText) + '&sort=' + this.sort + '&sortOrder=' + this.sortOrder + '&districtCode=' + data.districtCode + '&districtName=' + data.districtName + '&parentName=' + data.parentName + '&tierCity=' + data.tierCity + '&id=' + data.id)
    },
    onSelectedListChange (selectedlist) {
      this.selectedList = selectedlist
      if (selectedlist.length === 0) {
        this.delDisabled = true
      } else {
        this.delDisabled = false
      }
    },
    selectionChange (selection) {
      this.selectDomainData = []
      for (let i = 0; i < selection.length; i++) {
        this.selectDomainData.push(selection[i].id)
      }
      if (this.selectDomainData.length === 0) {
        this.delDisabled = true
      } else {
        this.delDisabled = false
      }
    },
    searchDomainList () {
      this.updateRouteQuery()
      this.currentPage = 1
      this.getAreaList(this.currentPage, this.pageSize, this.sort, this.sortOrder, this.searchText, this.parentId)
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.updateRouteQuery()
      // 请求列表接口数据
      this.getAreaList(this.currentPage, this.pageSize, this.sort, this.sortOrder, this.searchText)
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.updateRouteQuery()
      // 请求列表接口数据
      this.getAreaList(this.currentPage, this.pageSize, this.sort, this.sortOrder, this.searchText)
    },
    getAreaTreeData () {
      storeinformationApi.getAreaTree('get', 'basicdata/GetDistrict')
        .then(
          res => {
            this.districtData = res.data
            const area = {}
            area.id = '00000000-0000-0000-0000-000000000000'
            area.tierCity = null
            area.districtCode = null
            area.districtName = this.$t('LanguageLib.AREA1')
            this.districtData.unshift(area)
            console.log(this.districtData)
            var dtd = this.$commonfun.toRegionTree(res.data, 'childDomainTrees', 'id', 'parentId')
            console.log(dtd)
            this.districtTreeData = dtd
            // this.districtTreeData = [area]
            // this.districtData.push(this.districtTreeData[0].id)
          }
        ).catch(
          err => {
            this.$commonfun.console.log(err)
          }
        )
    },
    // 树组件传过来的数据-地区
    getTreeCheckDataRegion (data) {
      console.log(data)
      const parentId = data.id
      this.parentId = parentId
      this.parentName = data.districtName
      this.getAreaList(1, this.pageSize, this.sort, this.sortOrder, this.searchText, parentId)
    }
  }
}
</script>

<style lang="scss">
  #area {
    height: 100%;
    .left{
      background: #fff;
      width: 20%;
      float:left;
      height: 100%;
      border-right: 1px solid #f2f2f2;
      .treeBox{
        height: calc( 100% - 50px );
        overflow: auto;
        width: 100%;
      }
      .fifter{
        padding: 10px 0 10px 6%;
        line-height: 30px;
        .el-input{
          width: 60%;
        }
        .el-button--text{
          margin-left: 2.5%;
          padding: 2% 0;
          width: 20%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .right {
      width: 80%;
      margin-left: 20%;
      height: 100%;

      .operation {
        background: #fff;
        height: 30px;
        padding: 10px 0 10px 20px;
        border-bottom: 1px solid #f2f2f2;
        border-top: 1px solid #f2f2f2;

        .operationBtn {
          width: auto;
          display: inline-block;
          float: left;
          position: relative;

          .el-button {
            height: 30px;
            padding: 7px 20px;
          }

          .BatchSetting {
            background: #fff;
            color: #666666;
            position: absolute;
            left: 0;
            top: 30px;
            width: 100px;
            font-size: 14px;
            text-align: center;
            box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.2);
            border-radius: 2px;
            z-index: 99;

            li {
              line-height: 30px;
              cursor: pointer;
            }
          }

          .exportType {
            background: #fff;
            color: #666666;
            position: absolute;
            right: 0;
            top: 30px;
            min-width: 100px;
            font-size: 14px;
            text-align: center;
            box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.2);
            border-radius: 2px;
            z-index: 99;

            li {
              line-height: 30px;
              cursor: pointer;
              padding: 0 10px;
            }

            .upload {
              position: absolute;
              top: 30px;
              width: 100%;
              opacity: 0;

              .el-upload {
                width: 100%;

                button {
                  width: 100%;
                  padding-left: 0;
                }
              }
            }
          }
        }

        .operationSearch {
          float: right;
          padding-right: 51px;
          position: relative;

          .shaixuan {
            color: #999999;
            height: 15px;
            width: 15px;
            position: relative;
            top: 2px;
            margin-left: 10px;
            margin-right: 10px;
            font-weight: 600;
          }

          .shaixuan1 {
            color: #3BC6B9;
          }

          .el-input {
            width: 160px;

            .el-input__inner {
              height: 30px;
              line-height: 30px;
              border-radius: 20px;
            }
          }

          .el-icon-search {
            line-height: 30px;
          }
        }
      }

      .tableParent {
        height: calc(100% - 98px);
      }

      .el-pagination {
        padding: 8px 15px 5px;
        height: 35px;
        background: #fff;
      }
    }
    .drawerTitle{
      height:25px;
      font-size:18px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(77,77,77,1);
      line-height:25px;
      margin-bottom: 20px;
    }
    .drawerText{
      height:16px;
      font-size:14px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(77,77,77,1);
      line-height:16px;
      margin-bottom: 5px;
    }

    .el-button--primary{
      background-color:#3BC6B9;
      color:#fff;
      border:none;
      margin-left: 10px;
    }
    .el-button--primary:hover{
      background-color:#3BC6B9;
      color:#fff;
      border:none;
    }
    /*.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
      background-color: #3BC6B9 !important;
      border-color: #3BC6B9 !important;
    }*/
    // 对于树组件配置特有的css
    .el-tree-node>.el-tree-node__children{
      overflow: unset;
    }
    .el-tree-node__content{
      height: 48px;
    }
    .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
      background-color: #F6F6F6
    }
    // .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content>span:last-child{
    //   color: #3BC6B9 !important;
    // }
    // .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content>ww-open-data{
    //   color: #3BC6B9 !important;
    // }
    // 更改表格的滚动条样式
    .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar,
    .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }
    .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-thumb,
    .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb {
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
      background: #E1E1E1;
    }
    .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-track,
    .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-track {
      border-radius: 5px;
      background: #fff;
    }
    // 抽屉组件样式修改
    .el-drawer.rtl{
      outline: none;
    }
    .el-drawer__wrapper{
      top: 172px;
      bottom: 18px;
      /*  right: 20px;*/
    }
    section.el-drawer__body{
      padding: 20px;
      .el-input{
        margin-bottom: 15px;
      }
    }
    .el-drawer__container{
      outline: none;
    }
    .colorG{
      height:20px;
      font-size:14px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(59,198,185,1);
      line-height:20px;
    }
    .el-table .descending .sort-caret.descending{
    }
    .el-table .ascending .sort-caret.ascending{
      border-bottom-color: #3BC6B9;
    }
    .el-pager li.active{
      color: #3BC6B9;
    }
    .el-table__fixed-body-wrapper .el-table__body{
      padding-bottom: 10px;
    }
    .filterContent{
      height: calc(100% - 154px);
      overflow: hidden;
      overflow-y: auto;
    }
    .filterContent::-webkit-scrollbar{
      width: 10px;
      height: 10px;
    }
    .filterContent::-webkit-scrollbar-thumb {
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
      background: #E1E1E1;
    }
    .filterContent::-webkit-scrollbar-track {
      border-radius: 5px;
      background: #fff;
    }
    .el-table-column--selection{
      text-align: center !important;
    }
    .el-tooltip__popper.is-light{
      box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
      border: 1px solid #E4E7ED !important;
      background-color: #fff;
      color: #000;
      .popper__arrow{
        border-top-color: #E4E7ED;
        border: #E4E7ED;
      }
      .popper__arrow::after{
        border-top-color: #fff;
      }
    }
  }
</style>
